import { ConfigStore } from './ConfigStore';
import { Container } from 'hypo-container';
import { CommunicationsApiSdk } from '../api';
import { ServiceBusController } from './ServiceBusController';
import { getDecorators } from '@estee/elc-service';
import { FormValidator } from '@estee/elc-form';
import { CommunicationsService } from './CommunicationsService';
import { root } from '@estee/elc-universal-utils';
import { EmailOptInViewController } from '~controllers/EmailOptInViewController';
import { EmailOptInRepository } from '~repositories/EmailOptInRepository';
import { ProductNotifyMeViewController } from '~controllers/ProductNotifyMeViewController';
import { ProductNotifyMeRepository } from '~repositories/ProductNotifyMeRepository';
import { NotifyMeForm } from '~domain/entities/NotifyMeForm';
import { ViewEmailOptInViewController } from '~controllers/ViewEmailOptInViewController';
import serviceNames from '~setup/CommunicationsService';
export const diContainer = new Container();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(
        serviceNames.notifyMeForm,
        diContainer.factory(
            (c) =>
                new NotifyMeForm({
                    notifyMeFormValidator: c.get(serviceNames.notifyMeFormValidator)
                })
        )
    )
    .register(serviceNames.serviceBusController, (c) => new ServiceBusController())
    .register(
        serviceNames.communicationsService,
        (c) =>
            new CommunicationsService((config: {}) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    )
    .register(serviceNames.communicationsApiSdk, (c) => {
        const config = {
            httpTransport: c.get(serviceNames.httpTransport)
        };

        return new CommunicationsApiSdk(config);
    })
    .register(serviceNames.notifyMeFormValidator, (c) => new FormValidator())
    .register(
        serviceNames.emailOptInRepository,
        (c) =>
            new EmailOptInRepository({
                apiSdk: c.get(serviceNames.communicationsApiSdk)
            })
    )
    .register(
        serviceNames.productNotifyMeRepository,
        (c) =>
            new ProductNotifyMeRepository({
                communicationApiSdk: c.get(serviceNames.communicationsApiSdk),
                notifyMeForm: c.get(serviceNames.notifyMeForm)
            })
    )
    .register(serviceNames.httpTransport, (c) => {
        return root.HttpTransport;
    })
    .register(serviceNames.emailOptInViewController, (c) => new EmailOptInViewController())
    .register(
        serviceNames.productNotifyMeViewController,
        diContainer.factory((c) => new ProductNotifyMeViewController())
    )
    .register(serviceNames.viewEmailOptInViewController, (c) => new ViewEmailOptInViewController());
const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
